import React from 'react';

export default function ReportHeader({ school, report, student }) {
  return (
    <div className="rc-header">
      {/* Left: school logo */}
      {school?.logo && (
        <div>
          <img src={school.logo} alt="logo" className="rc-logo" />
        </div>
      )}

      {/* Centre: school info */}
      <div className="rc-header-info">
        <h1 className="rc-school-name">{school?.name || 'School Name'}</h1>
        {school?.motto && <p className="rc-motto">"{school.motto}"</p>}
        {(school?.address || school?.city) && (
          <p className="rc-address">
            {[school.address, school.city, school.district, school.country].filter(Boolean).join(', ')}
          </p>
        )}
        {(school?.phone || school?.email) && (
          <p className="rc-contact">
            {[school.phone, school.email, school.website].filter(Boolean).join(' | ')}
          </p>
        )}
        <p className="rc-report-title">Student Report Card</p>
        <p className="rc-term-label">
          {report?.term?.name || 'Term'}&nbsp;&nbsp;|&nbsp;&nbsp;Academic Year: <strong>{report?.academic_year || ''}</strong>
        </p>
      </div>

      {/* Right: student photo */}
      <div>
        {student?.picture_url && (
          <img src={student.picture_url} alt="student" className="rc-bio-photo" />
        )}
      </div>
    </div>
  );
}
